import { type WidgetType } from '../../../Widget.ts';
import { type IInputWidget } from '../IInputWidget.ts';

export enum TextWidgetKind {
  Text = 'text',
  TextArea = 'textarea',
}

/**
 * Input Testo
 */
export interface ITextWidget extends IInputWidget {
  type: WidgetType.Text;
  kind: TextWidgetKind;
  placeholder?: string;
}
